import { FC, useEffect, useState } from 'react';
import './LayoutComponent.scss';
import LayoutProps from './LayoutComponentProps';
import { MdMenuOpen, MdMenu, MdOutlineLogout  } from "react-icons/md";
import { MdOutlineHouse  } from "react-icons/md";
import { useContext } from 'react';
import UserContext from '../../../domain/providers/user/UserContext';
import UserContextType from '../../../domain/providers/user/UserContextType';
import { routes, modules, iRouteModule } from '../../routes/RoutesComponent';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthLayoutComponent from './authLayout/AuthLayoutComponent';
import di from '../../../di/DependencyInjection';
import LocalizationContext from '../../../domain/providers/localization/LocalizationContext';
import LocalizationContextType from '../../../domain/providers/localization/LocalizationContextType';
import KeyWordLocalization from '../../providers/localization/dictionaries/KeyWordLocalization';
import ModalsComponent from '../../providers/modals/modals/ModalsComponent';
import SignOutUseCase, { SignOutUseCaseName } from '../../../domain/use_cases/auth/SignOutUseCase';
import TrackingTimeComponent from '../trackingTime/TrackingTimeComponent';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { GetNewsUseCase, GetNewsUseCaseName } from '../../../domain/use_cases/ai/GetNewsUseCase';
import { isRight } from 'fp-ts/lib/Either';
import ModalsContext from '../../../domain/providers/modal/ModalsContext';
import ModalsContextType from '../../../domain/providers/modal/ModalsContextType';

const LayoutComponent: FC<LayoutProps> = ({ children }) => {
  const { i18n } = useContext(LocalizationContext) as LocalizationContextType;
  const { user } = useContext(UserContext) as UserContextType;
  const { openModalCustom } = useContext(ModalsContext) as ModalsContextType;
  const location = useLocation();
  const navigate = useNavigate();

  const [open, setOpen] = useState<boolean>(window.screen.width > 780);
  const [openOptionMenu, setOpenOptionMenu] = useState<string | undefined>(undefined);
  const [news, setNews] = useState<any>(null);
  const [isLoadingNews, setIsLoadingNews] = useState<boolean>(false);
  
  const validateClientAccess = (user: any, clientRestrictions?: string[]) => {
    return !clientRestrictions || !!(user?.business_unit && clientRestrictions.includes(user.business_unit));
  };

  const _handleSignOut = async () => {
    await di.get<SignOutUseCase>(SignOutUseCaseName).call();
    navigate(routes.signin.path);
  }

  const _userCanAccessToModule = (module: iRouteModule) => {
    return module.page?.auth(user) || 
           module.pages.some(page => page.auth(user)) ||
           (module.subPages && Object.values(module.subPages).flat().some(page => page.auth(user)));
  };

  const _handleToggleOptionMenu = (name: string) => {
    if (openOptionMenu == name) setOpenOptionMenu(undefined);
    else setOpenOptionMenu(name);
  }

  const _handleOpenNewsList = () => {
    // Convert news to array if it's a single object
    const newsArray = Array.isArray(news) ? news : (news ? [news] : []);
    const validNews = newsArray.filter((item: any) => item.url && item.url !== null);
    
    if (validNews.length === 0) return;

    const NewsListContent = () => (
      <div style={{ padding: '20px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {validNews.map((item: any, index: number) => (
            <div 
              key={index}
              onClick={() => {
                const ImageModalContent = () => (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <img 
                      src={item.url} 
                      alt="News" 
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '70vh', 
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                      }} 
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = '/assets/images/no-results.png';
                      }}
                    />
                  </div>
                );
                openModalCustom('lg', '', <ImageModalContent />);
              }}
              style={{
                padding: '15px',
                border: '1px solid #ddd',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                {item.title || `News ${index + 1}`}
              </div>
              {item.description && (
                <div style={{ color: '#666', fontSize: '14px' }}>
                  {item.description}
                </div>
              )}
              <div style={{ marginTop: '10px', color: '#007bff', fontSize: '12px' }}>
                Click to view image →
              </div>
            </div>
          ))}
        </div>
      </div>
    );

    openModalCustom('md', 'News', <NewsListContent />);
  };

  // Fetch news on component mount
  useEffect(() => {
    const fetchNews = async () => {
      setIsLoadingNews(true);
      try {
        const response = await di.get<GetNewsUseCase>(GetNewsUseCaseName).call();
        if (isRight(response)) {
          const result = JSON.parse(response.right as string);
          setNews(result);
        }
      } catch (error) {
        console.error('Error fetching news:', error);
      } finally {
        setIsLoadingNews(false);
      }
    };
    
    if (user) {
      fetchNews();
    }
  }, [user]);

  //on Changed page close the menu
  useEffect(() => {
    if(window.screen.width <= 780) setOpen(false);
    (window as any).gtag('event', 'page_view', {'page_path': location.pathname});
  }, [location.pathname])
  

  if (user == undefined) return <ModalsComponent><AuthLayoutComponent>{children}</AuthLayoutComponent></ModalsComponent>
  return <>
    <div className={`LayoutComponent ${open ? 'is_open' : ''}`}>
      {
        location.pathname !== "/home" ?
        <>
          <div className={`side_menu ${open ? 'open' : 'close'}`} style={{ backgroundImage: 'url(assets/bg/sidebar.png)' }}>
          <div className="header_side">
            <img src="/assets/logos/logo.png" className='logo' alt="" />
            <div className="text">
              <div className='title_app'><div className="text_bold">{i18n(KeyWordLocalization.TitleApp)}</div>{i18n(KeyWordLocalization.TitleApp2)}</div>
              <span>{user?.name}</span>
            </div>
          </div>
          <div className='home_link' onClick={() => {
            navigate("/home")
          }}>
            <MdOutlineHouse size={32} />
            <span>{i18n(KeyWordLocalization.RouteGoHome)}</span>
          </div>
          

          {modules.map((module, index) => _userCanAccessToModule(module)? <div className="module" key={index}>
            {module.page ? <Link to={module.page.relativePath as string} className={`header_module hover ${module.page.relativePath == window.location.pathname ? 'active_link' : ''}`}>
              <module.icon width={24} height={24} className="icon" />
              <span>{i18n(module.name)}</span>
            </Link> : <>
              <div className="header_module hover justify-content-between" onClick={() => _handleToggleOptionMenu(module.name)}>
                <div className='d-flex align-items-center'>
                  <module.icon width={24} height={24} className="icon" />
                  <span>{i18n(module.name)}</span>
                </div>
                {openOptionMenu == module.name ? <FaChevronUp size={24} className="icon" /> : <FaChevronDown size={24} className="icon rotate" />}
              </div>
              {(openOptionMenu == module.name || (openOptionMenu && openOptionMenu.startsWith(`${module.name}-`))) && module.pages.filter(page => page.auth(user)).map((page, index) =>
                <Link to={page.relativePath as string} className={`page_link hover ${page.relativePath == window.location.pathname ? 'active_link' : ''}`} key={index}>
                  {i18n(page.name)}
                </Link>)}
              {(openOptionMenu == module.name || (openOptionMenu && openOptionMenu.startsWith(`${module.name}-`))) && module.subPages && Object.entries(module.subPages).map(([subMenuName, subPages]) => 
                subPages.some(page => page.auth(user)) && (
                  <div key={subMenuName}>
                    <div className="page_link hover justify-content-between" onClick={() => _handleToggleOptionMenu(`${module.name}-${subMenuName}`)}>
                      <span>{subMenuName}</span>
                      {openOptionMenu == `${module.name}-${subMenuName}` ? <FaChevronUp size={16} /> : <FaChevronDown size={16} />}
                    </div>
                    {openOptionMenu == `${module.name}-${subMenuName}` && subPages.filter(page => page.auth(user)).map((page, index) =>
                      <Link to={page.relativePath as string} className={`subpage_link hover ${page.relativePath == window.location.pathname ? 'active_link' : ''}`} key={index}>
                        {i18n(page.name)}
                      </Link>)}
                  </div>
                )
              )}
            </>}
          </div> : '')}

          <div onClick={_handleSignOut} className="header_module hover mt-3">
            <MdOutlineLogout size={32} className="icon" />
            <span>{i18n(KeyWordLocalization.SignOut)}</span>
          </div>

        </div>
        <div className="right_side">
          <div className="header">
            {open ? <MdMenuOpen size={32} onClick={() => setOpen(false)} className="hover" /> : <MdMenu onClick={() => setOpen(true)} size={32} className="hover" />}
            <div onClick={_handleSignOut} className="header_module hover mt-3">
          </div>
            <div className="flex-grow-1 text-capitalize d-none d-md-block">
            </div>
            
            <div className="d-flex flex-row align-items-end align-items-center">
              <div className='d-flex flex-column-reverse flex-md-row align-items-end align-items-md-center'>
              {news && !isLoadingNews && (() => {
              // Check if there's any valid news with URL
              const newsArray = Array.isArray(news) ? news : (news ? [news] : []);
              const hasValidNews = newsArray.some((item: any) => item.url && item.url !== null && item.url !== undefined);
              const dotColor = hasValidNews ? '#28a745' : '#dc3545'; // Verde si hay URLs, rojo si no hay
              
              return (
                <div 
                  onClick={hasValidNews ? _handleOpenNewsList : undefined}
                  className="news-banner" 
                  style={{ 
                    padding: '0px 16px', 
                    marginBottom: '0px',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    cursor: hasValidNews ? 'pointer' : 'default',
                    fontWeight: 'normal'
                  }}
                >
                  <span>News</span>
                  <span 
                    style={{
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: dotColor,
                      display: 'inline-block'
                    }}
                  />
                </div>
              );
            })()}
                {user?.permissions?.timeTracking?.read ? 
                  <div className="me-md-4">
                    <TrackingTimeComponent />
                  </div>
                  : 
                  <></>
                }
                <div className="d-flex flex-column align-items-end">
                  <strong>{user?.name}</strong>
                  <span className='d-none d-md-block'>{user.email}</span>
                </div>
              </div>
              <div className="image_container">
                <img src={user?.image ?? '/assets/no_photo_profile.svg'} className='' alt="" />
              </div>
            </div>
            
          </div>
          <div className="content" id='content'>
            {children}
          </div>
        </div>
        </> : 
        <div className="content" id='content'>
          {children}
        </div>
      }
      
      
    </div>
  </>
};

export default LayoutComponent;
